import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      width: 300,
      display: 'block',
      padding: theme.spacing(4),
    },
  },
  links: {
    marginTop: theme.spacing(4),
  },
  link: {
    marginLeft: theme.spacing(1),
    textDecoration: 'underline',
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));



// WEBPACK FOOTER //
// ./src/components/Calculators/components/RightBar/useStyles.js